export default "__VITE_ASSET__ViMekBo0__"